import React, { useState } from "react";
import * as Components from "../../../components/all";

import Chart from "react-apexcharts";
import { useNavigate } from "react-router-dom";

import { FaUsers } from "react-icons/fa";
import { RiUserFollowFill } from "react-icons/ri";
import { IoTrendingDownOutline, IoTrendingUpOutline } from "react-icons/io5";
import { AiFillEye } from "react-icons/ai";

export default function Users() {
	const navigate = useNavigate();
	// eslint-disable-next-line no-unused-vars
	const [loading, setLoading] = useState(false);

	// Users Data
	var usersData = {
		totalUsers: 69908,
		userTrend: 9,
		activeUsers: 45090,
		activeTrend: 36,
		cityUserTrend: [
			{ city: "Islamabad", users: 4000 },
			{ city: "Lahore", users: 3000 },
			{ city: "Karachi", users: 1000 },
			{ city: "Rawalpindi", users: 2000 },
			{ city: "Gujrat", users: 1500 },
			{ city: "Mandibahauddin", users: 3000 },
		],
		allUsers: [
			{
				id: 1,
				name: "Abdul Hameed",
				city: "Islamabad",
			},
			{
				id: 2,
				name: "Abdul Haseeb",
				city: "Karachi",
			},
			{
				id: 3,
				name: "Abdul Mateen",
				city: "Lahore",
			},
			{
				id: 4,
				name: "Usman",
				city: "Gujrat",
			},
			{
				id: 5,
				name: "Anoosh",
				city: "Gujrat",
			},
			{
				id: 6,
				name: "Ali",
				city: "Rawalpindi",
			},
			{
				id: 7,
				name: "Hammad",
				city: "Chakwal",
			},
			{
				id: 8,
				name: "Asim",
				city: "Karachi",
			},
			{
				id: 9,
				name: "Johar",
				city: "Darra Adam Khel",
			},
			{
				id: 10,
				name: "Umer",
				city: "Faisalabad",
			},
		],
	};

	// Search Feature
	const [usersFilter, setUsersFilter] = useState(false);
	const [filterType, setFilterType] = useState("name");
	const [filteredUsers, setFilteredUsers] = useState([]);
	const search = (term) => {
		if (term === "") {
			setFilteredUsers([]);
			return;
		}

		const filtered = usersData.allUsers.filter(
			(x) =>
				(filterType === "name" ? x.name : x.city)
					.toLowerCase()
					.indexOf(term.toLowerCase()) > -1
		);
		setFilteredUsers(filtered);
	};

	// Settings
	var settings = {
		cityUsersGraph: {
			options: {
				chart: {
					type: "donut",
					stacked: false,
				},
				labels: usersData.cityUserTrend.map((x) => x.city),
				legend: {
					position: "bottom",
					horizontalAlign: "center",
				},
			},
			series: usersData.cityUserTrend.map((x) => x.users),
		},
	};

	return loading === true ? (
		<Components.Loader />
	) : (
		<div
			className="Users
            overflow-x-hidden overflow-y-auto 
            h-full 
            w-full
            sm:p-3 md:p-5
            flex flex-row flex-wrap
            "
		>
			{/* LEFT CARDS ROW */}
			<div
				className="LEFT-CARDS 
				flex flex-col
				sm:flex-[1.1]
				sm:min-w-[420px] 
				max-sm:w-full
				"
			>
				{/* left top cards */}
				<div className="LEFT-TOP-CARDS flex flex-col sm:flex-row sm:items-stretch sm:justify-between sm:flex-wrap flex-[1]">
					{/* card 1 */}
					<div
						style={{
							boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
						}}
						className="
						min-h-[120px] 
						sm:min-w-[300px] flex-1 
						rounded-md
						p-5 m-2
						bg-white 
						flex flex-col
						"
					>
						{/* heading */}
						<div className="flex items-center">
							<div
								className="
                            h-6 w-6 
                            flex items-center justify-center
                            rounded-full
                            bg-[#fedddd] 
                            text-[#FA9499]
                            "
							>
								<FaUsers />
							</div>

							<h1 className="ml-2 text-darker">Total Users</h1>
						</div>

						{/* data */}
						<div className="flex items-center justify-between mt-auto">
							<h1 className="text-3xl font-medium tracking-tighter">
								{usersData.totalUsers.toLocaleString()}
							</h1>

							<div className="">
								{usersData.userTrend > 0 ? (
									<div className="flex items-center justify-center text-green-400">
										<IoTrendingUpOutline />
										<h1 className="ml-1">{usersData.userTrend}%</h1>
									</div>
								) : (
									<div className="flex items-center justify-center text-red-400">
										<IoTrendingDownOutline />
										<h1 className="ml-1">{usersData.userTrend * -1}%</h1>
									</div>
								)}
								<h1 className="text-[#CCCCCC] text-[10px] font-medium opacity-70">
									in last 7 days
								</h1>
							</div>
						</div>
					</div>

					{/* card 2 */}
					<div
						style={{
							boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
						}}
						className="
						min-h-[120px] 
						sm:min-w-[300px] flex-1
						rounded-md
						p-5 m-2
						bg-white 
						flex flex-col
						"
					>
						{/* heading */}
						<div className="flex items-center">
							<div
								className="
                            h-6 w-6 
                            flex items-center justify-center
                            rounded-full
                            bg-[#dfe6ff] 
                            text-main
                            "
							>
								<RiUserFollowFill />
							</div>

							<h1 className="ml-2 text-darker">Active Users</h1>
						</div>

						{/* data */}
						<div className="flex items-center justify-between mt-auto">
							<h1 className="text-3xl font-medium tracking-tighter">
								{usersData.activeUsers.toLocaleString()}
							</h1>

							<div className="">
								{usersData.activeTrend > 0 ? (
									<div className="flex items-center justify-center text-green-400">
										<IoTrendingUpOutline />
										<h1 className="ml-1">{usersData.activeTrend}%</h1>
									</div>
								) : (
									<div className="flex items-center justify-center text-red-400">
										<IoTrendingDownOutline />
										<h1 className="ml-1">{usersData.activeTrend * -1}%</h1>
									</div>
								)}
								<h1 className="text-[#CCCCCC] text-[10px] font-medium opacity-70">
									in last 7 days
								</h1>
							</div>
						</div>
					</div>
				</div>

				{/* left bottom cards */}
				<div className="LEFT-BOTTOM-CARDS flex flex-col sm:flex-row sm:items-stretch sm:justify-between sm:flex-wrap flex-[5]">
					{/* card 1 */}
					<div
						style={{
							boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
						}}
						className="
						min-h-[400px] sm:min-h-[520px] 
						sm:min-w-[400px] 
						flex-1 
						max-sm:max-w-full 
						p-5 m-2
						rounded-md
						bg-white 
						flex flex-col
						overflow-hidden
						"
					>
						{/* heading */}
						<div className="p-2 pt-0 w-full">
							<div className="flex items-center justify-between">
								<h1 className="text-xl">Users</h1>
							</div>
							<p className="text-dark text-sm">Total users in each city</p>
						</div>

						{/* data */}
						<div className="w-full flex-1 overflow-hidden">
							<Chart
								options={settings.cityUsersGraph.options}
								series={settings.cityUsersGraph.series}
								type="donut"
								height="100%"
								width="100%"
							/>
						</div>
					</div>
				</div>
			</div>

			{/* RIGHT CARDS ROW */}
			<div
				className="RIGHT-CARDS 
				flex flex-col 
			    sm:flex-1
				overflow-hidden
				sm:min-w-[500px] 
				max-sm:w-full
			"
			>
				{/* card 1 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="
                    min-h-[380px] sm:min-h-[480px] h-full 
                    p-5 m-2
                    rounded-md
                    bg-white 
                    flex flex-col
                    overflow-auto
                    "
				>
					{/* heading */}
					<div className="p-2 py-0 w-full">
						<div className="flex items-center justify-between">
							<h1 className="text-xl">Search Users</h1>
							{/* <button
								className="text-xs text-main hover:opacity-80"
								onClick={() => navigate("/trends")}
							>
								View Details
							</button> */}
						</div>
						{/* <p className="text-dark text-sm">
							Trends by user registration and activity
						</p> */}
					</div>

					{/* filters */}
					<div className="w-full">
						{/* selection */}
						<div className="w-full flex p-2 pt-0 justify-end">
							<button
								className={`
							text-sm 
							px-3 py-1 mx-1
							rounded-full
							flex items-center
							duration-200 ease-in-out
							${usersFilter === true ? "bg-main text-white" : "bg-bg text-dark"}
							`}
								onClick={() => setUsersFilter(true)}
							>
								Filters
							</button>

							<button
								className={`
							text-sm 
							px-3 py-1 mx-1
							rounded-full
							duration-200 ease-in-out
							${usersFilter === false ? "bg-main text-white" : "bg-bg text-dark"}
							`}
								onClick={() => setUsersFilter(false)}
							>
								All Users
							</button>
						</div>
					</div>

					{/* search */}
					<div
						className={`
						mb-4 mt-2 p-1 bg-gray-50 rounded
						${usersFilter === true ? " flex" : "hidden"}
						`}
					>
						<div className="relative flex-1">
							<div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
								<svg
									className="w-5 h-5 text-gray-500"
									aria-hidden="true"
									fill="currentColor"
									viewBox="0 0 20 20"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fillRule="evenodd"
										d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
										clipRule="evenodd"
									></path>
								</svg>
							</div>
							<input
								type="text"
								className="w-full block p-1.5 pl-10 text-sm text-gray-900  border-gray-300 rounded bg-gray-50 focus:outline-none"
								placeholder="Search for users"
								onChange={(e) => search(e.target.value)}
							/>
						</div>

						<div className="flex items-center justify-end">
							<button
								className={`
							text-xs 
							px-3 py-1 mx-1
							rounded-full
							flex items-center
							duration-200 ease-in-out
							${filterType === "name" ? "bg-main text-white" : "bg-bg text-dark"}
							`}
								onClick={() => setFilterType("name")}
							>
								Name
							</button>

							<button
								className={`
							text-xs 
							px-3 py-1 mx-1
							rounded-full
							duration-200 ease-in-out
							${filterType === "city" ? "bg-main text-white" : "bg-bg text-dark"}
							`}
								onClick={() => setFilterType("city")}
							>
								City
							</button>
						</div>
					</div>

					{/* data */}
					<div className="max-h-[calc(100vh)] 2xl:max-h-[calc(100vh-220px)] flex-1 overflow-y-auto">
						{/* table */}
						<div className="h-fit w-full overflow-y-hidden overflow-x-auto shadow-md sm:rounded">
							<div className="overflow-hidden min-w-max">
								<table className="w-full text-sm text-left text-gray-500">
									<thead className="text-xs text-gray-700 uppercase bg-gray-50">
										<tr>
											<th scope="col" className="px-6 py-3">
												Name
											</th>
											<th scope="col" className="px-6 py-3">
												City
											</th>
											<th scope="col" className="px-3 py-3">
												Details
											</th>
										</tr>
									</thead>

									<tbody className="">
										{(usersFilter === false
											? usersData.allUsers
											: filteredUsers
										).map(({ id, name, city }, index) => (
											<tr
												key={index}
												className="bg-white border-b hover:bg-gray-50"
											>
												<th
													scope="row"
													className="px-6 py-4 font-medium text-darker whitespace-nowrap"
												>
													{name}
												</th>
												<td className="px-6 py-4">{city}</td>
												<td className="py-4">
													<p
														className="text-blue-400 hover:underline flex items-center w-fit
														cursor-pointer
														pl-6
														"
														onClick={() => navigate(`/users/user/${id}`)}
													>
														<AiFillEye size={20} />
													</p>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
